import {Explorer} from '@apps-common/ui-icons';
import GeoJsonFormat from 'ol/format/GeoJSON';
import WktFormat from 'ol/format/WKT';
import {func, object} from 'prop-types';
import React from 'react';
import MenuItem from '../../common/MenuItem.jsx';
import {trackEvent} from '@app/analytics';
import {EXPLORER_URL} from '@app/config.js';

const JumpToExplorer = ({feature, onClick, ...props}) => {
  const handleOnClick = () => {
    // this is wasteful and we should likey have a direct conversion
    //  without the openlayers interloper
    const olFeature = new GeoJsonFormat().readFeature(feature);
    const wkt = new WktFormat().writeGeometry(olFeature.getGeometry());
    window.open(`${EXPLORER_URL}#/geometry/${wkt}`);
    trackEvent('Jump to Explorer', {
      featureId: feature.id,
    });

    if (onClick) {
      onClick();
    }
  };

  return (
    <MenuItem
      onClick={handleOnClick}
      label="Search here"
      icon={<Explorer />}
      {...props}
    />
  );
};

JumpToExplorer.propTypes = {
  feature: object,
  onClose: func,
  onClick: func,
};

export default JumpToExplorer;
